import { ImageLoaderProps } from 'next/image';

// This is currently used for next/images on dutchie+ shop pages
export const imageLoader = ({ src, width, quality }: ImageLoaderProps) => {
  return `${src}?w=${width}&h=${width}&q=${quality || 75}&fit=fill&fill=solid`;
};
